export const CAR_BUYING_EVENTS = {
  CONVERSION: 'car_buying.conversion',
  PAGE_LOAD: 'car_buying.page_load',
  LIST: 'car_buying.list',
  SAVE_VEHICLE: 'car_buying.save_vehicle',
  CARCODE_LOADED: 'car_buying.carcode_loaded',
  ZIP_CHANGE: 'car_buying.zip_change',
  APPRAISAL_MANUALLY_CHANGE: 'car_buying.appraizal_manually_change',
  CHANGE_DELIVERY_DATE_TIME: 'car_buying.change_delivery_date_time',
  CHECK_DELIVERY_OPTION: 'car_buying.check_delivery_option',
  DEALER_OFFERS_HOME_DELIVERY_ACTION: 'car_buying.dealer_offers_home_delivery',
  REQUEST_HOME_DELIVERY_ACTION: 'car_buying.request_home_delivery',
  OPEN_CARCODE_CHAT: 'car_buying.open_carcode_chat',
  TOGGLE_DETAILS: 'car_buying.toggle_details',
  SLIDER_MOVE: 'car_buying.slider_move',
  LEAD_FORM_STEP_CHANGE: 'car_buying.lead_form_step_change',
  VIN_CHANGE: 'car_buying.vin_change',
  SMS_OPEN_TARGET: 'car_buying.sms_open_target',
  DEAL_CHECK_CORE_ENTRY: 'car_buying.deal_check_core_entry',
  PRICE_FOCUSED_DEAL_CHECK_VEHICLE_CARD: 'car_buying.price_focused_deal_check_vehicle_card',
  PRE_QUALIFY_FORM_ENTRY: 'car_buying.pre_qualify_form_entry',
  DEAL_CHECK_CALCULATOR_TOGGLE: 'car_buying.deal_check_calculator_toggle',
  DEAL_CHECK_SMS_CHECKBOX: 'deal_check_sms_checkbox',
};
